import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import OutstandingApplicationsSection from "./OutstandingApplicationsSection";
import React from "react";
import AccessRequestSection from "./AccessRequestSection";
import TabLabel from "components/TabLabel/TabLabel";
import { selectAllIncomingAccessRequestEntities } from "store/domain-data/access-request/accessRequest";
import { useStoreDispatch, useStoreSelector } from "store/hooks";
import { fetchAccessRequests } from "store/domain-data/access-request/accessRequest";

type Props = {};

enum OustandingActionTabs {
  Applications = "Applications",
  AccessRequests = "AccessRequests",
}

const OutstandingActionsSection: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useStoreDispatch();
  const [selectedTab, setSelectedTab] = React.useState(OustandingActionTabs.Applications);
  const incomingAccessRequests = useStoreSelector(selectAllIncomingAccessRequestEntities);

  React.useEffect(() => {
    dispatch(fetchAccessRequests());
  }, [dispatch]);

  const handleTabChange = React.useCallback((evt, value) => {
    setSelectedTab(value);
  }, []);

  return (
    <React.Fragment>
      <Tabs aria-label={"Dashboard Tabs"} data-testid={"DashboardTabs"} value={selectedTab} onChange={handleTabChange}>
        <Tab label={t("Required Actions")} value={OustandingActionTabs.Applications} />
        <Tab
          label={<TabLabel label={t("Access Requests")} adornment={incomingAccessRequests.length} />}
          value={OustandingActionTabs.AccessRequests}
        />
      </Tabs>

      {selectedTab === OustandingActionTabs.Applications && <OutstandingApplicationsSection />}
      {selectedTab === OustandingActionTabs.AccessRequests && <AccessRequestSection />}
    </React.Fragment>
  );
};

export default OutstandingActionsSection;
